/* REQ-019 S2 · the dedication's order data, without the old designer.
   Until 23.10 the old designer (#pmModal in snippets/pampas-dedication.liquid) was never shown but still held the page's design in
   hidden fields (#pmBodyText, #pmFromText, #pmHeart, #pmTpls), and the new editor clicked its hidden "אישור העיצוב" so that its
   approveCurrent() wrote the cart properties. This file keeps that state in memory and writes the same properties, with the same names
   and values, so the order, the print file and the cart do not change.
   - window.PMDedication: templates, chips, fields, approve / approveShown / approveUnit, the "approved" signal.
   - field('body'|'from'|'heart'): an object with value (checked for the heart) and DOM-style events, so the product-page block
     (assets/pampas-sticker-pdp.js) and the editor (assets/pampas-sticker-editor.js) read and write it as they did the old fields.
   - an approval from the editor (approve(..., {fromEditor: true})) dispatches 'pm:design-approved' {target, mode}: the print script
     makes the PDF on it (it used to listen for the hidden button's click).
   - window.pmDesigner stays as an alias for one release (decision D3 at G2). */
(function () {
  'use strict';
  if (window.PMDedication) return;
  var cfg = document.getElementById('pmDedicationCore');
  var TPLS = window.pmTemplates || { free: { label: 'חופשי', chip: 'טקסט חופשי', text: '' } };
  var ORDER = ['free', 'rabot', 'mizmor', 'birkat', 'mazal', 'toda'].filter(function (k) { return TPLS[k]; })
    .concat(Object.keys(TPLS).filter(function (k) { return ['free', 'rabot', 'mizmor', 'birkat', 'mazal', 'toda'].indexOf(k) < 0; }));
  var want = cfg && cfg.dataset.pmDefaultTpl;
  var DEF = want && TPLS[want] && TPLS[want].text ? want : 'toda';

  function Field(kind) { this.kind = kind; this._v = kind === 'heart' ? true : ''; this._t = document.createElement('span'); }
  Field.prototype.addEventListener = function (t, f, o) { this._t.addEventListener(t, f, o); };
  Field.prototype.removeEventListener = function (t, f, o) { this._t.removeEventListener(t, f, o); };
  Field.prototype.dispatchEvent = function (e) { return this._t.dispatchEvent(e); };
  Field.prototype.setSelectionRange = function () {};
  Object.defineProperty(Field.prototype, 'value', { get: function () { return this.kind === 'heart' ? (this._v ? 'on' : '') : this._v; }, set: function (v) { if (this.kind === 'heart') this._v = !!v; else this._v = v == null ? '' : String(v); } });
  Object.defineProperty(Field.prototype, 'checked', { get: function () { return !!this._v; }, set: function (v) { this._v = !!v; } });
  var F = { body: new Field('body'), from: new Field('from'), heart: new Field('heart') };
  var S = { tpl: DEF, font: 'Secular One', approved: '' };
  var listeners = [];
  function fire(f, type) { f.dispatchEvent(new Event(type, { bubbles: true })); }
  function noHeart(k) { return !!(TPLS[k] && TPLS[k].noHeart); }

  /* = a click on the old #pmTpls button: the template and its wording (free text keeps the current wording) */
  function setTpl(k) {
    if (!TPLS[k]) return;
    S.tpl = k;
    if (TPLS[k].text) F.body.value = TPLS[k].text;
    if (noHeart(k)) F.heart.checked = false;
    fire(F.body, 'input');
  }
  function reset() { S.tpl = DEF; F.body.value = TPLS[DEF].text || ''; F.from.value = ''; F.heart.checked = true; }
  function notify() { listeners.slice().forEach(function (cb) { try { cb(S.approved); } catch (e) { console.error(e); } }); }
  function setApproved(text) { S.approved = text || ''; notify(); }
  function addProp(f, n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; i.dataset.ded = '1'; f.appendChild(i); }
  function isUnit(t) { return !!(t && t.matches && t.matches('[data-pm-item-design]')); }
  /* the wording as approveCurrent() built it: the greeting without trailing space, then "מאת" on its own line when it adds something */
  function wording(st, quote) {
    var full = String(st.body || '').replace(/\s+$/, '');
    if (!full.trim() && quote) full = String(quote);
    if (!full.trim()) return null;
    var fr = String(st.from || '');
    if (fr.trim() && full.trim() !== fr.trim()) full += '\n' + fr.replace(/\s+$/, '');
    return full;
  }
  function snapshot() { return { tpl: S.tpl, body: F.body.value, from: F.from.value, heart: F.heart.checked }; }
  function writeTarget(t, full, st) { t.value = full; t._pmDesignerState = st; t.dataset.pmDesigned = '1'; t.dispatchEvent(new Event('input', { bubbles: true })); }

  /* opts: mode ('standalone' | 'sticker'), target (an add-on's text box or a unit's field), fromEditor, quote (the editor's first text) */
  function approve(source, opts) {
    opts = opts || {};
    var mode = opts.mode || 'standalone', target = opts.target || null;
    if (isUnit(target)) {
      /* one unit: only its own box (Ran 20.10). The old path reloaded the box's text into the designer with an empty "מאת". */
      var ut = wording({ body: target.value }, null);
      if (ut == null) return fail();
      writeTarget(target, ut, { tpl: DEF, body: target.value, from: '', heart: true });
      if (opts.fromEditor) emit(target, mode);
      return ut;
    }
    var full = wording({ body: F.body.value, from: F.from.value }, opts.quote);
    if (full == null) return fail();
    if (target) writeTarget(target, full, snapshot());
    var form = opts.form || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.querySelectorAll('[data-ded]').forEach(function (i) { i.remove(); });
      addProp(form, 'properties[טקסט הקדשה]', full);
      addProp(form, 'properties[תבנית]', (TPLS[S.tpl] || TPLS[DEF]).label);
      addProp(form, 'properties[פונט]', S.font);
      addProp(form, 'properties[לב מצויר]', (F.heart.checked && !noHeart(S.tpl)) ? 'כן' : 'לא');
      addProp(form, 'properties[סוג עיצוב]', mode === 'greeting' ? 'ברכה' : 'מדבקת הקדשה');
      addProp(form, 'properties[_מקור אישור העיצוב]', source);
      /* REQ-010: the full design model (hidden property) so the studio can rebuild it; image data is left out */
      if (window.PMStickerModel && !target) {
        try {
          var mm = JSON.parse(JSON.stringify(window.PMStickerModel, function (k, v) { return (k === 'logo' || k === 'src') && typeof v === 'string' && v.length > 200 ? '[תמונה מצורפת]' : v; }));
          addProp(form, 'properties[_עיצוב]', JSON.stringify(mm));
          var xs = (mm.extras || []).length; if (xs) addProp(form, 'properties[אלמנטים נוספים]', String(xs));
        } catch (e) {}
      }
    }
    setApproved('ההקדשה אושרה: ' + full.split('\n')[0]);
    if (opts.fromEditor) emit(target, mode);
    return full;
  }
  function fail() { document.dispatchEvent(new CustomEvent('pm:design-error', { detail: { message: 'כתבו כאן את הברכה' } })); return null; }
  function emit(target, mode) { document.dispatchEvent(new CustomEvent('pm:design-approved', { detail: { target: target, mode: mode } })); }

  /* REQ-004: the add approves the design the page shows (the default template, or the customer's edits) */
  function approveShown(m) { if (!F.body.value.trim()) reset(); return approve('אושר בהוספה לעגלה', { mode: m || 'standalone' }); }
  /* a unit never opened in the editor: its saved state, else its typed text, else the default wording */
  function approveUnit(t) {
    var sv = t._pmDesignerState || null;
    var st = sv ? { body: sv.body || t.value.trim(), from: sv.from || '' } : { body: t.value.trim(), from: '' };
    if (!String(st.body).trim()) st = { body: TPLS[DEF].text || '', from: '' };
    var full = wording(st, null);
    if (full == null) return fail();
    writeTarget(t, full, { tpl: sv ? sv.tpl : DEF, body: st.body, from: st.from, heart: sv ? sv.heart !== false : true });
    return full;
  }

  reset();
  window.PMDedication = {
    version: '1.0.0',
    templates: TPLS,
    defaultTemplate: DEF,
    /* the ready-made designs in page order, named as the old buttons were (chip), free text first */
    chips: function () { return ORDER.map(function (k) { return { k: k, label: TPLS[k].chip || (k === 'free' ? 'טקסט חופשי' : TPLS[k].label) }; }); },
    field: function (n) { return F[n]; },
    tpl: function () { return S.tpl; },
    setTpl: setTpl,
    font: function () { return S.font; },
    setFont: function (f) { if (f) S.font = String(f); },
    state: function () { return { tpl: S.tpl, body: F.body.value, from: F.from.value, heart: F.heart.checked, font: S.font, approved: S.approved }; },
    approve: approve,
    approveShown: approveShown,
    approveUnit: approveUnit,
    approved: function () { return S.approved; },
    clearApproved: function () { setApproved(''); },
    onApproved: function (cb) { if (typeof cb === 'function') listeners.push(cb); }
  };
  window.pmDesigner = { defaultTemplate: DEF, approveShown: approveShown, approveUnit: approveUnit };
})();
